export default function TrioBtn(props){


    return(
        <button onClick={props.extlink} className='triobtn'>{props.btntext}</button>
    )
}